import Vue from "vue";

Vue.component("wto-mail-to", {
	props: ["text"],
	data() {
		return {
			mailTo: ""
		};
	},
	methods: {
		extractEmail: function (text) {
			var returnValue = '';

			if (text) {
				var emails = text.match(/([a-zA-Z0-9._-]+@[a-zA-Z0-9._-]+\.[a-zA-Z0-9_-]+)/gi);
				emails.forEach(function (item) {
					returnValue += "<a href=mailto:" + item + ">" + item + "</a><br>"
				})
			}
			
			this.mailTo = returnValue;
		}
	},
	mounted() {
		this.extractEmail(this.text);
	},
	template: `
		<span v-html="mailTo"></span>
	`
});